var version = '1.3.0';
export default version;